define(
	'C3.ShoppingExtensions.PDP.MediaTab.View',
	[
		    'SCView'
		,   'c3_shoppingextensions_pdp_mediatab.tpl'
		,   'AjaxRequestsKiller'
		,   'GlobalViews.Breadcrumb.View'
		,   'Utils'
		,   'Backbone.CollectionView'
		,   'Facets.CategoryCell.View'
		
		,	'Backbone'
		],
	function(
		   SCViewComponent
		,  c3_shoppingextensions_pdp_mediatab_tpl
		,   AjaxRequestsKiller
		,   GlobalViewsBreadcrumbView
		,   Utils
		,   BackboneCollectionView
		,   FacetsCategoryCellView
		,	Backbone
		) {
		'use strict';

		var SCView = SCViewComponent.SCView;

		function PDPMediaTabView(options) {
			SCView.call(this);

			this.options = options || {};

			this.template = c3_shoppingextensions_pdp_mediatab_tpl;	
			this.application = options.application;
			this.siblingSrc = options.siblingSrc;	
		}

		// Inherit parent instance methods.
		PDPMediaTabView.prototype = Object.create(SCView.prototype);

		// Restore the constuctor.
		PDPMediaTabView.prototype.constructor = PDPMediaTabView;

		PDPMediaTabView.prototype.getContext = function() {
			
			return {
				src : this.siblingSrc
			};
		}

		return PDPMediaTabView;
	}

);
